export const fetch_purchase_history_api = "eud/transactions/purchase/history";
export const fetch_renew_booking_availability_api = "host/listing/availability";
export const cancel_subscription_api = "payments/revoke/customer/subscription";
export const fetch_subscriptions_api = "payments/customer/subscription/history";
export const PURCHASE_HISTORY_API_KEY = "purchase_history";
